import { Fill, Stroke, Style } from 'ol/style';
import { baseStyle } from '@vendor/libs/maps/styles/base';
export const infectionStyle = () => {
    const style = infectionRegularStyle();
    style.setFill(new Fill({
        color: 'rgba(225,13,9,0.25)',
    }));
    return style;
};
export const infectionRegularStyle = () => {
    return new Style({
        stroke: new Stroke({
            color: '#a20500',
            width: 2,
        }),
        fill: new Fill({
            color: 'rgba(162,5,0,0.18)',
        }),
    });
};
export const infectionHighlightedStyle = () => {
    return new Style({
        stroke: new Stroke({
            color: '#a20500',
            width: 2,
        }),
        fill: new Fill({
            color: 'rgba(162,5,0,0.5)',
        }),
    });
};
export default (feature, resolution) => {
    return baseStyle(feature, resolution, () => {
        if (feature.get('highlighted')) {
            return infectionHighlightedStyle();
        }
        return infectionRegularStyle();
    });
};
